import { useState, useEffect } from 'react';

export type NetworkStatus = 'online' | 'offline' | 'unknown';

export const useNetworkStatus = () => {
  const [status, setStatus] = useState<NetworkStatus>(
    typeof navigator !== 'undefined' && 'onLine' in navigator
      ? navigator.onLine ? 'online' : 'offline'
      : 'unknown'
  );

  useEffect(() => {
    const handleOnline = () => setStatus('online');
    const handleOffline = () => setStatus('offline');

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const isOffline = status === 'offline';
  const isOnline = status === 'online';

  return { status, isOffline, isOnline };
};
